/**
 * RenderLocation identifies the location where a component is rendered on the page.
 * Used for analytics tracking purposes to understand where user interactions occur.
 */
export enum RenderLocation {
    DOWNLOAD_PAGE = "download-page",
    DOWNLOAD_POST_FOOTER = "download-post-footer",
    HERO = "hero",
    PRE_FOOTER = "pre-footer",
}
